import { useQuery } from 'react-query';
import { getSubscriptionBlockUseCases } from '@subscriptions/composition';
import type { SubscriptionBlockViewDto } from '@subscriptions/application/dtos';

/**
 * Hook for getting a specific subscription block by ID.
 *
 * @param blockUuid - Block UUID
 * @param options - Optional query configuration
 * @returns Query result with subscription block detail
 */
export const useSubscriptionBlock = (blockUuid: string, options?: { enabled?: boolean }) => {
  const { getSubscriptionBlock } = getSubscriptionBlockUseCases();

  return useQuery<SubscriptionBlockViewDto, Error>(
    ['subscriptions', 'blocks', 'detail', blockUuid],
    () => getSubscriptionBlock.execute(blockUuid),
    {
      enabled: options?.enabled ?? !!blockUuid,
      refetchOnWindowFocus: false,
    },
  );
};
